
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:host{
  --sic-promo--default--content-padding:clamp(
    var(--spacing-05),
    calc(0.43rem + 5.37vw),
    var(--spacing-20)
  );
  --sic-promo--default--text-size:var(--body-03-font-size);
  --sic-promo--default--text-line-height:var(--body-03-line-height);
  --sic-promo--default--text-spacing:var(--spacing-04);
  --sic-promo--default--cta-spacing:var(--spacing-08);
  --sic-promo--default--border-radius:var(--border-radius-rounded-default);
}
`;